import React from 'react';
import {FormattedMessage} from 'react-intl';
import {TELEGRAM_SUPPORT} from '../../constants';
import {LinkButton} from '../button/button';
import MessangerGroupIcon from '../../assets/messenger-group.svg';
import './cta-support.scss';

const CtaSupport = () => {
    return (
        <div className='cta-support background-color-gray-50 min-height-5rem border-radius-1rem'>
            <div className='padding-left-1dot25rem-14rem padding-right-1dot25rem-14rem'>
                <div className='padding-top-2rem display-flex justify-content-center'>
                    <MessangerGroupIcon/>
                </div>
                <div className='text-xl medium color-gray-900 text-align-center margin-top-minus1dot25rem'>
                    <FormattedMessage defaultMessage='Questions left?'/>
                </div>
                <div className='text-md color-gray-500 padding-top-0dot5rem text-align-center'>
                    <FormattedMessage defaultMessage={`Didn't find the answer, have a complaint or a wish?`}/>
                </div>
                <div className='text-align-center padding-top-1dot5rem padding-bottom-2rem'>
                    <LinkButton link={{target: '_blank', rel: 'noopener noreferrer', href: TELEGRAM_SUPPORT}} color='primary-gradient' size='lg' >
                        <FormattedMessage defaultMessage='Contact us'/>
                    </LinkButton>
                </div>
            </div>
        </div>
    );
};

export default React.memo(CtaSupport);


